import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { NO_PRACTICE } from '@atlassian/jira-servicedesk-request-type-practices/src/common/constants.tsx';
import type { NewTicketType, TicketTypeResponse } from '../../common/types.tsx';

export const createTicketTypeUrl = (projectId: number) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/request-types`;

export const createTicketTypeService = (
	newTicket: NewTicketType,
	projectId: number,
	groupIds: number[],
): Promise<TicketTypeResponse> => {
	const { name, description, iconId, issueType, practices } = newTicket;
	const url = createTicketTypeUrl(projectId);
	let options = {
		body: JSON.stringify({
			description,
			icon: iconId,
			issueTypeId: issueType,
			name,
			groupIds,
		}),
	};

	const hasPractice = practices && practices[0] && practices[0] !== NO_PRACTICE;
	if (hasPractice) {
		options = {
			body: JSON.stringify({
				description,
				icon: iconId,
				issueTypeId: issueType,
				name,
				groupIds,
				practice: practices[0],
			}),
		};
	}

	return performPostRequest(url, options);
};
